import * as React from 'react';

import {EmptyInvoicesTableIcon} from 'shells/icon/svg/empty-invoices-table';
import {EmptyQuotesTableIcon} from 'shells/icon/svg/empty-quotes-table';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {SalesDocumentVariant} from 'nutshell-graphql-types';

type Props = {
    hasAnyFilters: boolean;
    type: SalesDocumentVariant;
};

export function SalesDocumentOverviewEmptyState(props: Props) {
    const lowerCaseType = props.type.toLowerCase();
    const mainText = props.hasAnyFilters
        ? `No ${lowerCaseType}s found`
        : `No ${lowerCaseType}s created yet`;

    return (
        <div className='flex flex-dir-col gap-16 align-center justify-center mt-32 pt-16'>
            {props.type === 'INVOICE' ? (
                <EmptyInvoicesTableIcon size={128} />
            ) : (
                <EmptyQuotesTableIcon size={128} />
            )}
            <div className='text-align-center'>
                <Body color='light' as='div'>
                    {mainText}
                </Body>
                {props.hasAnyFilters && (
                    <div className='pt-4'>
                        <Body color='light'>Try loosening your search</Body>
                    </div>
                )}
            </div>
            {!props.hasAnyFilters && (
                <Link
                    variant='button-primary'
                    size='big'
                    href={`#/create/${props.type.toLowerCase()}s`}
                >
                    + Add {props.type === 'INVOICE' ? 'an invoice' : 'a quote'}
                </Link>
            )}
        </div>
    );
}
